import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { useHotkeys } from 'react-hotkeys-hook';
import moment from 'moment';


import PrivateLayout from "../layouts/PrivateLayout/PrivateLayout";
import { authAction, userAgencyAction, profileAction } from "./../redux/actions";
import history from "../config/history";
import { getDefaultChatRoomPreference } from "../utils";
import useIdleTimeChecker from "../hooks/useIdleTimeChecker";

// Routes the page without any authentication by the user
const PrivateRoute = ({ component: Component, ...rest }) => {


  // Define Dispatch and State
  const dispatch = useDispatch();

  const { ag_owner, id: id1, agency_pref, signupData } = useSelector(s => s.auth.loginUser);
  const [key, setKey] = useState("");
  const hasKey = localStorage.getItem('key');

  useEffect(() => {
  }, [rest.path, rest?.location?.pathname])

  useEffect(() => {
  }, [signupData])

  useEffect(() => {
    // Get users timezone
    const userTimeZone =
      Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone || "UTC";
    const params = {
      time_zone: userTimeZone
    }
    if (hasKey) {
      dispatch(authAction.getProfileData(params, () => { }));
      dispatch(userAgencyAction.getUserAgencies());
      // dispatch(userAgencyAction.getPlanDetails())
      //   dispatch(profileAction.getNotifications({ limit: 20, offset: 0}));
      //   dispatch(profileAction.getOtherNotification());
      //   dispatch(profileAction.getWorkspaceNotification());
      //   dispatch(profileAction.getTasks());
    }
    return () => {
      dispatch(userAgencyAction.clearUserAgencies());
    };
  }, [dispatch, hasKey]);

  const getDefaultChatRoom = () => {
    const { type } = getDefaultChatRoomPreference()
    return type
  }

  useEffect(() => {
    if (key === "d") {
      history.push("/home")
    } else if (key === "c") {
      history.push("/clients")
    } else if (key === "f") {
      history.push("/leads")
    } else if (key === "p") {
      history.push("/settings/profile")
    } else if (key === "t") {
      history.push("/tasks")
    }
  }, [key])

  //keyboard routes
  useHotkeys('g+d', () => { setKey("d"); })
  useHotkeys('g+c', () => { setKey("c"); })
  useHotkeys('g+f', () => { setKey("f"); })
  useHotkeys('g+h', () => { setKey("h"); })
  useHotkeys('g+i', () => { setKey("i"); })
  useHotkeys('g+p', () => { setKey("p"); })
  useHotkeys('g+t', () => { setKey("t"); })
  useHotkeys('g+a', () => { setKey("a"); })

  useIdleTimeChecker()

  return (
    <Route {...rest} render={props => (
      <PrivateLayout {...props}>
        <Component {...props} />
      </PrivateLayout>
    )} />)
};

// Define Props Types
PrivateRoute.propTypes = {
  component: PropTypes.elementType
};

export default PrivateRoute;
